import styled from "@emotion/styled";

export const Container = styled.div`
  max-width: 600px;
  margin: auto;
  background: #f8f8f8;
  padding: 20px;
  border: 1px solid #eee;
  .ant-card-cover {
    img {
      height: 200px;
      width: 100%;
      object-fit: cover;
    }
  }
`;

export const NoStores = styled.div`
  text-align: center;
`;
